import { render, staticRenderFns } from "./SentSummaryHeader.vue?vue&type=template&id=7c1276be&scoped=true&"
import script from "./SentSummaryHeader.vue?vue&type=script&lang=js&"
export * from "./SentSummaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./SentSummaryHeader.vue?vue&type=style&index=0&id=7c1276be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1276be",
  null
  
)

export default component.exports